/* eslint-disable */
import * as React from 'react';

import AppPage from '@/ui/AppPage/AppPage';
import Box from '@mui/material/Box';
import Permissions from '@/lib/permissions';
import RegistarProstornihPlanovaTable from './RegistarProstornihPlanovaTable';

function RegistarProstornihPlanovaPage() {
  return (
    <AppPage
      titlett="admin:page.registar_prostornih_planova"
      needPermission={[Permissions.Administration]}
    >
      <Box m={0} style={{ height: '100%' }}>
        <RegistarProstornihPlanovaTable />
      </Box>
    </AppPage>
  );
}

export default RegistarProstornihPlanovaPage;
